"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @fileoverview 函数相关
 * @author kirkzheng
 */

/**
* 空的辅助函数
*/
var noop = exports.noop = function noop() {};

exports.default = {
  noop: noop
};